import { ApplicationHeader } from "./ApplicationHeader";
import { Page } from "@client/components/utils/Page";
import { Skeleton } from "@sfc/ui";

/** Keep loading content in the same page shell as the loaded content. */
export function ApplicationLoading({
  label = "Loading application",
  rows = 3,
  layout = "list",
}: {
  label?: string;
  rows?: number;
  layout?: "list" | "directory" | "questions";
}) {
  return (
    <div role="status" aria-label={label} className="space-y-4">
      <div aria-hidden="true" className="space-y-4">
        {Array.from({ length: rows }, (_, index) => (
          <div
            key={index}
            className={
              layout === "questions"
                ? "space-y-3 border-b border-border py-4"
                : layout === "directory"
                  ? "space-y-3 rounded-lg border border-border bg-card p-6 md:p-8"
                  : "space-y-3 rounded-lg border border-border bg-card p-5"
            }
          >
            {layout === "directory" && (
              <Skeleton className="h-4 w-36 motion-reduce:animate-none" />
            )}
            <Skeleton className="h-5 w-2/3 motion-reduce:animate-none" />
            <Skeleton className="h-4 w-1/3 motion-reduce:animate-none" />
          </div>
        ))}
      </div>
    </div>
  );
}

export function SavedApplicationLoading({
  editing = false,
}: {
  editing?: boolean;
}) {
  return (
    <Page spacing="compact" className="space-y-6">
      <ApplicationHeader backLabel={editing ? "Back to Application" : "Home"} />
      <div className="mx-auto w-full max-w-3xl">
        <ApplicationLoading layout="questions" />
      </div>
    </Page>
  );
}
